'use strict';
// @flow

import { combineReducers } from 'redux-immutable';

import lista from 'reducers/ferramentas/noticia/lista';
import detalhes from 'reducers/ferramentas/noticia/detalhes';

export default combineReducers({ lista, detalhes });
